import React, { createContext, useContext, useReducer } from 'react'
import { reducer, initialState } from './GlobalReducer'

export const StoreContext = createContext({})

export const GlobalStore = ({ children }) => (
  <StoreContext.Provider value={useReducer(reducer, initialState)}>
    {children}
  </StoreContext.Provider>
)

export const useStore = () => useContext(StoreContext)
